import {coreColors} from '../../../styles/shared/variables'
export const appBarStyle = {
    background: coreColors.grey400,
}

export const activePageDrawerOption = {
    background: coreColors.blue300,
    color: '#fff'
}

export const inactivePageDrawerOption = {
    color:'#fff'
}




// WEBPACK FOOTER //
// ./src/tabs/appBars/styles/mobileStyle.js